import { getSamples } from "@/api/endpoints";
import { RecordListPage } from "@/components/record-list-page";
import { Badge } from "@/components/ui/primitives";
import { useI18n } from "@/i18n";
import type { Sample } from "@/types";

export function SamplesPage() {
  const { t } = useI18n();

  return (
    <RecordListPage<Sample>
      title={t("navSamples")}
      resource="samples"
      fetcher={getSamples}
      renderRow={(sample) => (
        <div className="flex items-center gap-3">
          <div className="min-w-0 flex-1">
            <p className="truncate font-medium">{sample.name}</p>
            {sample.storageLocation && (
              <p className="truncate text-sm text-muted-foreground">
                {sample.storageLocation}
              </p>
            )}
          </div>
          {sample.receivedDate && (
            <Badge>{new Date(sample.receivedDate).toLocaleDateString()}</Badge>
          )}
        </div>
      )}
    />
  );
}
